// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1iRrm","actions":"GroupTable_actions__21NbU","deleteModalFooter":"GroupTable_deleteModalFooter__1hRFh"};